<header #header [enableImpersonation]="true" brandImage="../../assets/common/header/logo-randstad.png"
  brandImageAlt="Randstad">
  <launcher-mobile mobileMenuSection></launcher-mobile>
  <office-selector userActions></office-selector>
  <div userActions style="display: flex; flex-direction: row; flex-wrap: nowrap; justify-content: flex-end;">
    @if (impersonationEnabled) {
      <impersonation-menu></impersonation-menu>
    }
    <help [compactView]="impersonationEnabled"></help>
  </div>
</header>
<div class="container-fluid rs-container">
  <div class="row">
    <launcher></launcher>

    <loading-overlay [show]="loading" style="width: 100%;">
      <div class="col-12 col-md-12 col-lg-12 col-xl-12 bd-content" style="max-width: 100%;">
        <!-- Mensajes -->
        @if (message.show) {
          <div class="row">
            <div class="col-sm-12">
              <div class="alert alert-{{message.type}}">
                <div>
                  <span>{{ message.body }}</span>
                  <button type="button" class="close" (click)="clearMessage()">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        }

        <!-- Formulario de Novedades -->
        <div class="row">
          <div class="col-md-12">
            @if (form) {
              <form name="form" [formGroup]="form">
                <div class="row">
                  <div class="col-md-12">
                    <section class="panel panel-default">
                      <div class="panel-heading clearfix">
                        <h3 class="panel-title" aria-controls="collapsedForm">
                          {{ titleForm }}
                        </h3>
                      </div>

                      <div class="panel-body panel-collapse" id="collapsedForm">

                        <div class="row">
                          <!-- Título -->
                          <div class="col-md-12">
                            <div class="form-group">
                              <label for="ff_platformsadm_formcompanydoc_file">
                                Título de la novedad (*)
                              </label>
                              <input id="ff_platformsadm_formcompanydoc_file" type="text" formControlName="title"
                                class="form-control" [required]="!form.get('title').value">

                              <!-- Errores validación -->
                              @if (form.get('title').dirty || form.get('title').touched) {
                                @if (form.get('title').errors?.required) {
                                  <span class="error-msg">
                                    El título es obligatorio
                                  </span>
                                }

                                @if (form.get('title').errors?.maxlength) {
                                  <span class="error-msg">
                                    Campo máximo de 300 caracteres
                                  </span>
                                }
                              }
                            </div>
                          </div>

                          <!-- Visible para -->
                          <div class="col-md-12">
                            <div class="form-group">
                              <label for="ff_platformsadm_formcompanydoc_file">
                                Visible para
                              </label>
                              <div class="row">
                                <div class="col-md-2">
                                  ETT <input id="ff_platformsadm_formcompanydoc_file" type="checkbox"
                                    formControlName="visibleEttChk">
                                </div>
                                <div class="col-md-10">
                                  <div class="row">
                                    <div class="col-md-2">
                                      RPS <input id="ff_platformsadm_formcompanydoc_file" type="checkbox"
                                        formControlName="visibleRpsChk">
                                    </div>
                                    <div class="col-md-2">
                                      VEXTER <input id="ff_platformsadm_formcompanydoc_file" type="checkbox"
                                        formControlName="visibleVexChk">
                                    </div>
                                    <div class="col-md-2">
                                      TECH <input id="ff_platformsadm_formcompanydoc_file" type="checkbox"
                                        formControlName="visibleTechChk">
                                    </div>
                                    <div class="col-md-2">
                                      PROF <input id="ff_platformsadm_formcompanydoc_file" type="checkbox"
                                        formControlName="visibleProfChk">
                                    </div>
                                    <div class="col-md-2">
                                      FUNDACIÓN <input id="ff_platformsadm_formcompanydoc_file" type="checkbox"
                                        formControlName="visibleFunChk">
                                    </div>
                                    <div class="col-md-2">
                                      RPO <input id="ff_platformsadm_formcompanydoc_file" type="checkbox"
                                        formControlName="visibleRpoChk">
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <!-- Errores validación -->
                              @if (form.get('visibleEttChk').dirty || form.get('visibleEttChk').touched ||
                                  form.get('visibleRpsChk').dirty || form.get('visibleRpsChk').touched ||
                                  form.get('visibleVexChk').dirty || form.get('visibleVexChk').touched ||
                                  form.get('visibleTechChk').dirty || form.get('visibleTechChk').touched ||
                                  form.get('visibleProfChk').dirty || form.get('visibleProfChk').touched ||
                                  form.get('visibleFunChk').dirty || form.get('visibleFunChk').touched ||
                                  form.get('visibleRpoChk').dirty || form.get('visibleRpoChk').touched) {

                                  @if (form.get('visibleEttChk').errors?.visibleTo || form.get('visibleRpsChk').errors?.visibleTo ||
                                      form.get('visibleVexChk').errors?.visibleTo || form.get('visibleTechChk').errors?.visibleTo ||
                                      form.get('visibleProfChk').errors?.visibleTo || form.get('visibleFunChk').errors?.visibleTo
                                      || form.get('visibleRpoChk').errors?.visibleTo) {
                                      <span class="error-msg">
                                        Debe seleccionar al menos una compañía
                                      </span>
                                  }
                              }
                            </div>
                          </div>

                          <!-- Adjuntar documento -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="ff_platformsadm_formcompanydoc_file">
                                Adjuntar documento
                              </label>
                              <input id="ff_platformsadm_formcompanydoc_file" type="file" formControlName="file"
                                class="form-control" accept=".ppt, pptx, .doc, .docx, .xls, .xlsx, .pdf"
                                placeholder="Seleccione un archivo..." (change)="changeFile($event)">
                              @if (form.get('file').value) {
                                <i class="material-icons cancel-file" title="Eliminar"
                                  (click)="cancelFile()">close</i>
                              }

                              <!-- Errores validación -->
                              @if (form.get('file').dirty || form.get('file').touched) {
                                @if (form.get('file').errors?.fileVn) {
                                  <span class="error-msg">
                                    La extensión del archivo no está permitida (.ppt, .pptx, .doc, .docx, .xls, .xlsx, .pdf)
                                  </span>
                                }
                              }
                            </div>
                          </div>

                          <!-- Adjuntar video -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="ff_platformsadm_formcompanydoc_file">
                                Adjuntar video
                              </label>
                              <input id="ff_platformsadm_formcompanydoc_file" type="text" formControlName="url"
                                class="form-control">

                              <!-- Errores validación -->
                              @if (form.get('url').dirty || form.get('url').touched) {
                                @if (form.get('url').errors?.pattern) {
                                  <span class="error-msg">
                                    Url de video no válida
                                  </span>
                                }
                              }

                            </div>
                          </div>

                          <!-- Fecha inicio -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="ff_platformsadm_formcompanydoc_file">
                                Fecha de inicio (*)
                              </label>
                              <input id="ff_platformsadm_formcompanydoc_file" type="date" formControlName="begDate"
                                class="form-control" [required]="!form.get('begDate').value">

                              <!-- Errores validación -->
                              @if (form.get('begDate').dirty || form.get('begDate').touched) {
                                @if (form.get('begDate').errors?.required) {
                                  <span class="error-msg">
                                    La fecha de inicio es obligatoria
                                  </span>
                                }

                                @if (form.get('begDate').errors?.begDateVn) {
                                  <span class="error-msg">
                                    No debe ser mayor que la fecha fin
                                  </span>
                                }
                              }
                            </div>
                          </div>

                          <!-- Fecha inicio -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="ff_platformsadm_formcompanydoc_file">
                                Fecha fin (*)
                              </label>
                              <input id="ff_platformsadm_formcompanydoc_file" type="date" formControlName="endDate"
                                class="form-control" [required]="!form.get('endDate').value">

                              <!-- Errores validación -->
                              @if (form.get('endDate').dirty || form.get('endDate').touched) {
                                @if (form.get('endDate').errors?.required) {
                                  <span class="error-msg">
                                    La fecha fin es obligatoria
                                  </span>
                                }

                                @if (form.get('endDate').errors?.endDateVn) {
                                  <span class="error-msg">
                                    No debe ser menor que la fecha de inicio
                                  </span>
                                }
                              }
                            </div>
                          </div>

                        </div>

                        <div class="col-md-12 text-center">
                          <button type="button" class="btn btn-danger" (click)="cancelFrmNovelty()">Cancelar</button>
                          <button type="reset" class="btn btn-light ms-2">Limpiar</button>
                          <button type="submit" class="btn btn-primary ms-2" [disabled]="!form?.valid"
                            (click)="saveNovelty()">Guardar</button>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </form>
            }
          </div>
        </div>

        <!-- Lista de novedades -->
        <div class="row">
          <div class="col-md-12">
            <section class="panel panel-default">

              <div class="panel-heading clearfix">
                <h3 class="panel-title">
                  Listado de Novedades
                  <a class="btn btn-primary btn-back" (click)="backToHome()">Volver</a>
                </h3>
              </div>

              <div class="panel-body">
                <div class="header-table">
                  <div class="inner">
                    <div class="btn-group">
                      <button type="button" class="btn btn-primary">
                        <span>Todos los resultados </span>
                        @if (novelties) {
                          <span>({{novelties.length}})</span>
                        }
                      </button>
                    </div>

                    <!-- Acciones Listado -->
                    <div ngbDropdown (click)="$event.stopPropagation()" style="float: right;"
                      class="btn-group btn-group-dropdown">
                      <span ngbDropdownToggle aria-haspopup="true" aria-expanded="false" data-offset="10,10"
                        class="btn btn-primary">
                        Acciones
                      </span>
                      <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="avatar">
                        <button class="dropdown-item" (click)="throwNewNolvety()">Nuevo</button>
                        <button class="dropdown-item" [disabled]="!selectedNovelty"
                          (click)="throwEditNovelty()">Modificar</button>
                        <button class="dropdown-item" [disabled]="!selectedNovelty"
                          (click)="throwDeleteNovelty()">Eliminar</button>
                      </div>
                    </div>

                  </div>
                </div>

                <!-- Listado -->
                <div class="table-responsive table-sidebar mb-3">
                  <table class="table table-randstad table-bordered table-hover">
                    <thead>
                      <tr>
                        <th style="border-left: 1px solid #ddd;"></th>
                        <th class="text-start">
                          @if (novelties && novelties.length > 0) {
                            <div class="hidden-xs order"
                              (click)="orderBy('title')">
                              <span class="order-label">Título</span>
                              @if (currentFilterParams.properties === 'title' && currentFilterParams.typeOrder === 'ASC') {
                                <i class="material-icons order-asc">arrow_drop_up</i>
                              }

                              @if (currentFilterParams.properties === 'title' && currentFilterParams.typeOrder === 'DESC') {
                                <i class="material-icons order-desc">arrow_drop_down</i>
                              }

                              @if (currentFilterParams.properties !== 'title') {
                                <div class="order-both">
                                  <i class="material-icons order-both-asc">arrow_drop_up</i>
                                  <i class="material-icons order-both-desc">arrow_drop_down</i>
                                </div>
                              }
                            </div>
                          }
                        </th>
                        <th class="text-center">ETT</th>
                        <th class="text-center">RPS</th>
                        <th class="text-center">VEXTER</th>
                        <th class="text-center">TECH</th>
                        <th class="text-center">PROF</th>
                        <th class="text-center">FUNDACIÓN</th>
                        <th class="text-center">RPO</th>
                        <th class="text-center">
                          @if (novelties && novelties.length > 0) {
                            <div class="hidden-xs order"
                              (click)="orderBy('begDate')">
                              <span class="order-label">Fecha Inicio</span>
                              @if (currentFilterParams.properties === 'begDate' && currentFilterParams.typeOrder === 'ASC') {
                                <i class="material-icons order-asc">arrow_drop_up</i>
                              }

                              @if (currentFilterParams.properties === 'begDate' && currentFilterParams.typeOrder === 'DESC') {
                                <i class="material-icons order-desc">arrow_drop_down</i>
                              }

                              @if (currentFilterParams.properties !== 'begDate') {
                                <div class="order-both">
                                  <i class="material-icons order-both-asc">arrow_drop_up</i>
                                  <i class="material-icons order-both-desc">arrow_drop_down</i>
                              </div>
                              }
                            </div>
                          }
                        </th>
                        <th class="text-center">
                          @if (novelties && novelties.length > 0) {
                            <div class="hidden-xs order"
                              (click)="orderBy('endDate')">
                              <span class="order-label">Fecha Fin</span>
                              @if (currentFilterParams.properties === 'endDate' && currentFilterParams.typeOrder === 'ASC') {
                                <i class="material-icons order-asc">arrow_drop_up</i>
                              }

                              @if (currentFilterParams.properties === 'endDate' && currentFilterParams.typeOrder === 'DESC') {
                                <i class="material-icons order-desc">arrow_drop_down</i>
                              }

                              @if (currentFilterParams.properties !== 'endDate') {
                                <div class="order-both">
                                  <i class="material-icons order-both-asc">arrow_drop_up</i>
                                  <i class="material-icons order-both-desc">arrow_drop_down</i>
                                </div>
                              }
                            </div>
                          }
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      @if (novelties) {
                        @for (novelty of noveltiesPagination[paginationParams.currentIndex]; track novelty.noveltyId; let i = $index) {
                          <tr>
                            <td class="rand-fixed-column-sel" style="border: 1px solid #dee2e6;">
                              <input class="uk-checkbox" type="checkbox" id="check{{i}}" name="check{{i}}" value="{{i}}"
                                [checked]="novelty.noveltyId === selectedNovelty?.noveltyId"
                                (change)="checkNovelty(novelty)">
                            </td>
                            <td class="rand-fixed-column text-start" style="border: 1px solid #dee2e6;">{{ novelty.title }}
                            </td>
                            <td class="rand-fixed-column" style="border: 1px solid #dee2e6;">{{ novelty.visibleEttChk ?
                              'Si'
                              : 'No' }}</td>
                            <td class="rand-fixed-column" style="border: 1px solid #dee2e6;">{{ novelty.visibleRpsChk ?
                              'Si'
                              : 'No' }}</td>
                            <td class="rand-fixed-column" style="border: 1px solid #dee2e6;">{{ novelty.visibleVexChk ?
                              'Si'
                              : 'No' }}</td>
                            <td class="rand-fixed-column" style="border: 1px solid #dee2e6;">{{ novelty.visibleTechChk ?
                              'Si' : 'No' }}</td>
                            <td class="rand-fixed-column" style="border: 1px solid #dee2e6;">{{ novelty.visibleProfChk ?
                              'Si' : 'No' }}</td>
                            <td class="rand-fixed-column" style="border: 1px solid #dee2e6;">{{ novelty.visibleFunChk ?
                              'Si'
                              : 'No' }}</td>
                            <td class="rand-fixed-column" style="border: 1px solid #dee2e6;">{{ novelty.visibleRpoChk ?
                              'Si'
                              : 'No' }}</td>
                            <td class="rand-fixed-column" style="border: 1px solid #dee2e6;">{{ novelty.begDate }}</td>
                            <td class="rand-fixed-column" style="border: 1px solid #dee2e6;">{{ novelty.endDate }}</td>
                          </tr>
                        }
                      }

                      <!-- Si no hay resultados -->
                      @if (!novelties || novelties.length == 0) {
                        <tr>
                          <td colspan="11" class="text-center">No se encontraron resultados</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>

                <!-- Paginación -->
                @if (novelties) {
                  <div class="pagination justify-content-center">
                    <ngb-pagination [collectionSize]="novelties.length" [pageSize]="paginationParams.pageMaxSize"
                      [page]="paginationParams.currentPage" [maxSize]="10" [rotate]="true" [ellipses]="true"
                      [boundaryLinks]="true" (pageChange)="pagination($event)" class="text-center">
                    </ngb-pagination>
                  </div>
                }
              </div>
            </section>
            <a class="btn btn-primary btn-back" (click)="backToHome()">Volver</a>
          </div>
        </div>

        <modal-dialog detailDialog #modalDeleteNovelty [title]="'Eliminar Novedad'" okText="Eliminar"
          cancelText="Cancelar" [size]="2">
          <div class="col-md-12">
            <h3>¿Está seguro de eliminar la novedad seleccionada?</h3>
          </div>
        </modal-dialog>

      </div>
    </loading-overlay>
  </div>
</div>
